import { Button } from 'antd';
import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined
} from '@ant-design/icons';
import { HEADER_LANGUAGES } from './headerConstants';
import { StyledFullNameSpan, StyledRoleP } from './HeaderDropdowns';

export const getLocalizationMenu = (onLanguageMenuClick, i18n) => ({
  onClick: onLanguageMenuClick,
  items: Object.keys(HEADER_LANGUAGES).map(
    (locale) =>
      i18n.language === locale && {
        key: locale,
        label: (
          <>
            <span>{HEADER_LANGUAGES[locale].icon}</span>
            {` ${HEADER_LANGUAGES[locale].label}`}
          </>
        )
      }
  )
});

export const getProfileMenuItems = ({ user, t, navigate, profilePath }) => [
  ...(globalThis.innerWidth <= 992 && user
    ? [
        {
          key: 'user',
          label: (
            <Button
              style={{
                width: '100%',
                height: 50
              }}
              type="link"
            >
              <StyledFullNameSpan>
                {`${user.first_name} ${user.last_name}`}
              </StyledFullNameSpan>
              <StyledRoleP>
                {t(`users.tags.${user?.role?.split(':')[1]}`)}
              </StyledRoleP>
            </Button>
          )
        }
      ]
    : []),
  {
    key: 'profile',
    onClick: () => navigate(profilePath),
    label: (
      <>
        {' '}
        <UserOutlined
          style={{
            fontSize: 16,
            marginRight: 4
          }}
        />
        {` ${t('header.menu.user.profile')}`}
      </>
    )
  },
  {
    key: 'settings',
    onClick: () => navigate('/settings'),
    label: (
      <>
        <SettingOutlined
          style={{
            fontSize: 16,
            marginRight: 4
          }}
        />
        {` ${t('header.menu.user.settings')}`}
      </>
    )
  },
  {
    key: 'logout',
    label: (
      <>
        <LogoutOutlined
          style={{
            fontSize: 16,
            marginRight: 4
          }}
        />
        {` ${t('header.menu.user.logout')}`}
      </>
    )
  }
];
